var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
define(["require", "exports", "hypo_elements/Typescripts/Mustache/Mustache", "hypo_bvo/Drklein/Shared/BusinessCard", "hypo_bvo/Drklein/Shared/OfficeAllocationService", "libphonenumber-js", "jquery"], function (require, exports, HypoportMustache, BusinessCard_1, AgentStorage, libphonenumber_js_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    HypoportMustache = __importStar(HypoportMustache);
    AgentStorage = __importStar(AgentStorage);
    $(function () {
        var agentBusinessCard = $(".beraterVisitenkarte");
        function insertOfficeAllocationIntoBusinessCard(officeAllocation) {
            agentBusinessCard.find(".beraterVisitenkarteHead").each(function (index, element) {
                $(element).remove();
            });
            agentBusinessCard.prepend((0, BusinessCard_1.renderAgentBusinessCardHead)(agentBusinessCard.find("#beraterVisitenkarte_head"), officeAllocation));
            var $beraterVisitenkarteContact = agentBusinessCard.find(".beraterVisitenkarte_contact");
            var $addressTemplate = agentBusinessCard.find("#beraterVisitenkarte_address");
            var newAddress = HypoportMustache.render($addressTemplate, officeAllocation.office);
            $beraterVisitenkarteContact.find(".address").each(function (index, element) {
                $(element).remove();
            });
            $beraterVisitenkarteContact.find(".contactDetails").each(function (index, element) {
                $(element).remove();
            });
            $beraterVisitenkarteContact.append(renderAgentBusinessCardContactDetails(agentBusinessCard, officeAllocation.agent));
            $beraterVisitenkarteContact.append(newAddress);
        }
        function renderAgentBusinessCardContactDetails(agentBusinessCard, agent) {
            var $contactDetailsTemplate = agentBusinessCard.find("#beraterVisitenkarte_contactDetails");
            return HypoportMustache.render($contactDetailsTemplate, {
                festnetz: {
                    number: createHumanReadableNumber(agent.phoneNumber),
                    machineReadable: agent.phoneNumber,
                    type: '',
                },
                mobil: {
                    number: createHumanReadableNumber(agent.mobileNumber),
                    machineReadable: agent.mobileNumber,
                    type: ''
                },
                email: agent.email,
            });
        }
        function createHumanReadableNumber(originalNumber) {
            if (!originalNumber) {
                return '';
            }
            var phoneNumber = (0, libphonenumber_js_1.parsePhoneNumberFromString)(originalNumber);
            return phoneNumber ? phoneNumber.formatNational() : '';
        }
        function updateBusinessCard() {
            AgentStorage.getNearbyOfficeAllocation().then(function (officeAllocation) {
                insertOfficeAllocationIntoBusinessCard(officeAllocation);
            }).fail(function () { return agentBusinessCard.find(".beraterVisitenkarte_noBeraterFallback").slideDown(300); });
        }
        if (agentBusinessCard && agentBusinessCard.length > 0) {
            updateBusinessCard();
        }
    });
});
